module.exports = class SalonMainScreenDetails
  constructor: ->
    'ngInject'

  submit: ->
    @onSubmit(salon: @salon)
